import { createRouter, createWebHashHistory } from 'vue-router'

import LoginView from '../views/LoginView.vue'
import CreateContactView from '../views/CreateContactView.vue'
import DashboardView from '../views/DashboardView.vue'
import ContactlistView from '../views/ContactlistView.vue'
import ContactEditView from '../views/ContactEditView.vue'
import ContactDetailsView from '../views/ContactDetailsView.vue'

import { accountService } from '@/_services'

const routes = [

  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      requiresAuth: false,
    },

  },
  {
    path: '/createcontact',
    name: 'Créer un Contact',
    component: CreateContactView,
    meta: { 
      requiresAuth: true 
    },
  },
  {
    path: '/dashboard',
    name: 'Tableau de Bord',
    component: DashboardView,
    meta: { 
      requiresAuth: true 
    },
  },
  {
    path: '/contactlist',
    name: 'Liste de Contact',
    component: ContactlistView,
    meta: { 
      requiresAuth: true 
    },
  },
  {
    path: '/contactdetails/:id',
    name: 'Details du Contact',
    component: ContactDetailsView,
    meta: { 
      requiresAuth: true 
    },
  },
  {
    path: '/contactedit/:id',
    name: 'Modifier un Contact',
    component: ContactEditView,
    meta: { 
      requiresAuth: true 
    },
  },
  {
    path: '/:pathMatch(.*)*', redirect: '/login'
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  //const isLoggedIn = accountService.getToken() ? accountService.getToken() : null;
  const isLoggedIn = accountService.isLogged();

  if (to.meta.requiresAuth) {
    if (!isLoggedIn) {
      if (to.name !== 'Login') {
        next({ name: 'Login' });
      } else {
        next();
      }
      
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router
